import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/hire-ios-app-developers/bg-subbanner.webp";
import { StaticImage } from "gatsby-plugin-image";

function SubBanner() {
  return (
    <section
      className="hire-ios-app-developers-subbanner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row className="align-items-center justify-content-between">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="content">
              <h2 style={{ color: "#fff" }}>
                Delivering Results <span>that Matter</span>
              </h2>
              <p style={{ color: "#fff" }}>
                Accelerate MVP development and full-scale launch with expert iOS
                app developers.
              </p>
              <Link
                to="/contact"
                className="btn-pri"
                aria-label="Start Your Project Now"
              >
                Start Your Project Now
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={7} xxl={7} className="">
            <div className="image text-center">
              <StaticImage
                src="../../images/services-usa/hire-ios-app-developers/image-subbanner.webp"
                alt="Delivering Results that Matter"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={423}
                height={508}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SubBanner;
